import * as actionTypes from '../actions/actionTypes';


export default function userAdminReducer(state = {}, action) {
    switch(action.type){
      case actionTypes.SET_USER_ADMIN_DETAIL:
        return {
          ...action.data
        }
      default: return state;

    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/reducers/userAdminReducer.js